import React from "react";

import type CellProps from "./CellProps";

const Cell = <T,>({value, className}: CellProps<T>): JSX.Element => {
  return <div className={className}>{value as string}</div>;
};

export default Cell;
